import React from "react";
import { Link } from "react-router-dom";
import { EntryIcon, scrollToEntrySection } from "./PublicEntryUI";
import { formatAcquisitionMetric } from "../../utils/acquisitionFunnel";

function ProductIllustration() {
  return (
    <figure
      className="wp-home-visual"
      aria-label="Ilustración: tu página web conectada con pedidos, clientes y gestión"
    >
      <div className="wp-home-visual-label">
        <span className="wp-entry-status-dot" />
        Todo conectado
      </div>
      <div className="wp-home-site-card">
        <div className="wp-home-site-bar">
          <span className="wp-home-site-dots">
            <i />
            <i />
            <i />
          </span>
          <span>El espacio de tu negocio</span>
          <EntryIcon name="lock" size={13} />
        </div>
        <div className="wp-home-site-nav">
          <span>
            <i />
            Tu marca
          </span>
          <span>Inicio · Catálogo · Contacto</span>
        </div>
        <div className="wp-home-site-cover">
          <div>
            <span className="wp-home-site-eyebrow">HECHO A TU MEDIDA</span>
            <strong>
              Tu negocio.
              <br />
              Una nueva
              <br />
              forma de crecer.
            </strong>
            <span className="wp-home-site-line" />
          </div>
          <div className="wp-home-cover-art" aria-hidden="true">
            <div className="wp-home-art-circle" />
            <div className="wp-home-art-arch" />
            <div className="wp-home-art-small" />
          </div>
        </div>
        <div className="wp-home-site-bottom">
          <span>Tu página web</span>
          <span>
            Tu identidad, online
            <EntryIcon size={15} />
          </span>
        </div>
      </div>
      <div className="wp-home-connections" aria-hidden="true">
        <i />
        <i />
        <i />
      </div>
      <div className="wp-home-tools">
        {[
          { icon: "bag", title: "Ventas", text: "Pedidos y cobros" },
          { icon: "people", title: "Clientes", text: "Cada vínculo, cerca" },
          { icon: "chart", title: "Gestión", text: "Números en orden" },
        ].map((item) => (
          <div className="wp-home-tool" key={item.title}>
            <span>
              <EntryIcon name={item.icon} size={21} />
            </span>
            <strong>{item.title}</strong>
            <small>{item.text}</small>
          </div>
        ))}
      </div>
      <figcaption>
        Una web hacia afuera. Tu negocio conectado hacia adentro.
      </figcaption>
    </figure>
  );
}

// # HOME: one primary action. Explanation stays here; signup goes to the form.
export default function HeroSection({
  startHref = "/registro",
  onStartClick,
  stats = [],
  isAuthenticated = false,
  userName = "",
}) {
  return (
    <section className="wp-home-hero" aria-labelledby="webprofit-home-title">
      <div className="wp-entry-container">
        <div className="wp-home-hero-grid">
          <div className="wp-home-hero-copy">
            <p className="wp-entry-eyebrow">TU NEGOCIO, CON MENOS VUELTAS</p>
            <h1 id="webprofit-home-title">
              Tu negocio online.
              <br />
              <span>Todo más simple.</span>
            </h1>
            <p className="wp-home-hero-description">
              Tu página web, tus ventas y tu gestión, en un solo lugar. Empezá
              gratis con tu web y sumá herramientas a medida que las necesites.
            </p>
            {isAuthenticated && (
              <p className="wp-home-welcome">
                {userName ? `Hola, ${userName.split(" ")[0]}. ` : ""}Tu sesión
                está activa.
              </p>
            )}
            <div className="wp-home-hero-actions">
              <Link
                className="wp-entry-primary"
                to={startHref}
                onClick={onStartClick}
              >
                {isAuthenticated ? "Abrir mi panel" : "Crear cuenta gratis"}
                <EntryIcon size={20} />
              </Link>
              <button
                className="wp-entry-text-action"
                onClick={() => scrollToEntrySection("producto")}
              >
                Ver qué puedo hacer<span aria-hidden="true">↘</span>
              </button>
            </div>
            <p className="wp-home-hero-note">
              <EntryIcon name="check" size={16} />
              {isAuthenticated
                ? "Seguí donde lo dejaste."
                : "Solo nombre, email y contraseña para empezar."}
            </p>
          </div>
          <ProductIllustration />
        </div>
        {stats.length > 0 && (
          <dl className="wp-home-stats">
            {stats.slice(0, 3).map((item) => (
              <div key={item.key}>
                <dt>{item.label}</dt>
                <dd>{formatAcquisitionMetric(item.value)}</dd>
              </div>
            ))}
          </dl>
        )}
        <div className="wp-home-principle">
          <span>EMPEZÁ SIMPLE</span>
          <p>
            Tu página web es gratis.{" "}
            <strong>Las herramientas extra las elegís vos.</strong>
          </p>
          <EntryIcon name="plus" size={20} />
        </div>
      </div>
    </section>
  );
}
